import { render, staticRenderFns } from "./ReservationsEmpty.vue?vue&type=template&id=99566af0&"
import script from "./ReservationsEmpty.vue?vue&type=script&lang=js&"
export * from "./ReservationsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports